export default {
  焦虑: {
    h: "容易焦虑、紧张不安",
    l: "心态平静，遇事不慌张"
  },
  幻想: {
    h: "想象力丰富，有创造性的",
    l: "理性务实，实干主义"
  },
  正性情绪: {
    h: "有积极的情绪，乐观兴奋等",
    l: "平静严肃，不容易兴奋"
  },
  刺激追寻: {
    h: "喜欢冒险，追求新鲜刺激",
    l: "避免刺激，较为沉静"
  },
  活跃性: {
    h: "做事节奏快，精力充沛",
    l: "做事节奏慢，悠闲从容"
  },
  自我肯定: {
    h: "有领导性，有说服力的，自信果断",
    l: "谦逊腼腆，人群中话很少"
  },
  乐群性: {
    h: "喜欢与人相处、开朗合群",
    l: "尊重个人空间，爱独处"
  },
  热情性: {
    h: "热情好交际，健谈有情感",
    l: "离群索居，疏远他人"
  },
  脆弱性: {
    h: "处理压力能力较差，易惶恐",
    l: "压力下能保持镇定和清醒"
  },
  冲动性: {
    h: "不能抵抗诱惑，易冲动",
    l: "自控力强，能抵制诱惑"
  },
  自我意识: {
    h: "关注他人看法，自卑胆怯",
    l: "自信大方，善于社交"
  },
  抑郁: {
    h: "易受打击，经常情绪低落",
    l: "情绪稳定乐观 "
  },
  愤怒敌意: {
    h: "容易发火，受委屈时表现尤甚",
    l: "友好随和，不易动怒"
  },
  美感: {
    h: "审美水平高，对艺术感兴趣",
    l: "对艺术和美缺乏敏感性"
  },
  情感: {
    h: "重视个人感受，擅长感知自我",
    l: "感情较迟钝，不愿意坦率表达"
  },
  行动: {
    h: "喜欢寻求新异和多样性、尝试新的活动",
    l: "生活方式固定，喜欢熟悉的事务"
  },
  观念: {
    h: "有求知欲，善于分析",
    l: "聚焦具体事务，不喜思想挑战"
  },
  价值: {
    h: "勇于挑战权威和传统观念",
    l: "偏保守，接受权威，尊重传统"
  },
  信任: {
    h: "信任他人，宽容平和",
    l: "愤世嫉俗、有疑心"
  },
  坦诚: {
    h: "坦诚直接，有点老实",
    l: "精明机敏，防卫心重"
  },
  利他性: {
    h: "愿意帮助别人，热心慷慨",
    l: "不愿意帮助别人，冷酷的"
  },
  顺从性: {
    h: "恭顺随和，回避冲突",
    l: "有攻击性，喜欢竞争"
  },
  谦虚: {
    h: "谦逊，不爱出风头",
    l: "傲慢，爱炫耀"
  },
  温存: {
    h: "富有同情心，友好温和",
    l: "更关注真实、公平，同情心弱"
  },
  胜任感: {
    h: "自信高效，对生活有充分准备",
    l: "缺少自信，困惑健忘"
  },
  条理性: {
    h: "有良好的条理性，办事高效精确",
    l: "缺少计划和条理，粗心、易冲动"
  },
  责任心: {
    h: "有责任感，做事一丝不苟",
    l: "漠视规则，漫不经心"
  },
  事业心: {
    h: "追求成功和卓越，有进取心",
    l: "懒惰爱空想，缺乏抱负"
  },
  自律性: {
    h: "尽力完成工作和任务，克服困难",
    l: "做事拖延，经常半途而废"
  },
  审慎性: {
    h: "有逻辑性，深思熟虑",
    l: "冲动草率，做事不计后果"
  },
  // 核心版
  敏感性: {
    h: "情绪敏感，焦虑倾向强，缺乏安全感",
    l: "情绪稳定，抗压能力强，有安全感"
  },
  外倾性: {
    h: "主动社交，积极乐观，好动能量高",
    l: "内向自制，沉稳内敛，情绪低落"
  },
  开放性: {
    h: "勇于尝试，思维灵活，开放包容",
    l: "恐惧变化，思想死板，传统僵化"
  },
  宜人性: {
    h: "有好温和，信任他人，富同情心",
    l: "直言直接，态度强硬，缺乏同情心"
  },
  尽责性: {
    h: "自律控制力强，计划性好，事事踏实",
    l: "随心所欲，反复无常，行动散漫"
  }
} as Record<string, { h: string; l: string }>;
